import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import scrollTo from '../../utils/scroll-to';

class ScrollToTop extends Component<RouteComponentProps> {
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);

        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    handleScroll = () => {
        const {
            location: { pathname, search }
        } = this.props;
        const href = pathname + search;
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if (window.sessionStorage) {
            window.sessionStorage.setItem(
                href,
                JSON.stringify({ scrollHeight: document.body.scrollHeight, scrollPosition })
            );
        }
    };

    componentDidUpdate(prevProps: RouteComponentProps) {
        const {
            history: { action },
            location: { pathname, search }
        } = this.props;
        const prevHref = prevProps.location.pathname + prevProps.location.search;
        const href = pathname + search;

        if (prevHref !== href) {
            if (action === 'POP' && window.sessionStorage) {
                const sessionInfo = window.sessionStorage.getItem(href);

                if (sessionInfo) {
                    const { scrollPosition } = JSON.parse(sessionInfo);
                    const i = setInterval(() => {
                        if (!Object.keys(window.pendingRequests).length) {
                            clearInterval(i);
                            window.requestAnimationFrame(() => {
                                scrollTo(Number(scrollPosition));
                            });
                        }
                    }, 100);
                }
            } else if (search.indexOf('tab=') < 0 && search.indexOf('query=') < 0) {
                window.requestAnimationFrame(() => {
                    window.scrollTo(0, 0);
                });
            }
        }
    }

    render() {
        return null;
    }
}
export default withRouter(ScrollToTop);
